import axios from "axios";

export async function addToken() {
  try {
    const res = await axios.post("https://my-pg.vercel.app/token/", {
      username: "chakri",
      password: "chakri",
    });
    // console.log(res.data);
    localStorage.clear();
    localStorage.setItem("access_token", res.data.access);
    localStorage.setItem("refresh_token", res.data.refresh);
    // console.log(res.data.access);
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + res.data["access"];
  } catch (error) {
    console.log(error);
  }
}

export async function searchUser(user, pwd) {
  try {
    const res = await axios.get(
      "https://my-pg.vercel.app/user/?username=" + user + "&password=" + pwd
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    return console.log(error);
  }
}

export async function validateUser(user, mobileno, eamil) {
  try {
    const res = await axios.get(
      "https://my-pg.vercel.app/users/?username=" +
        user +
        "&mobileno=" +
        mobileno +
        "&email=" +
        eamil
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    return console.log(error);
  }
}

export function addUser(user) {
  return (axios
    .post("https://my-pg.vercel.app/user/", {
      username: user.username,
      email: user.email,
      mobileno: user.mobileno,
      password: user.password,
    })
    .then((res) => {
      // console.log(res);
      alert("User created successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

/* **********PG Related Api's************/

export async function getPgDetails() {
  try {
    const res = await axios.get("https://my-pg.vercel.app/pg/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getPgDetailsByOwner(owner) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/pg/?owner=" + owner);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getPgByID(id) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/pg/" + id + "/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}
export function addPg(pg) {
  return (axios
    .post("https://my-pg.vercel.app/pg/", {
      id: null,
      pgname: pg.pgname,
      rooms: pg.rooms,
      owner: pg.owner,
    })
    .then((res) => {
      // console.log(res);
      alert("PG created successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export function updatePg(pg, id) {
  return (axios
    .put("https://my-pg.vercel.app/pg/" + id + "/", {
      id: null,
      pgname: pg.pgname,
      rooms: pg.rooms,
      owner: pg.owner,
    })
    .then((res) => {
      // console.log(res);
      alert("PG updated successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

/* **********Rooms Related Api's************/

export async function getRoomDetails() {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Room/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getRoomDetailsByPg(pg) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Room/?pgname=" + pg);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getRoomByID(id) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Room/" + id + "/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export function addRoom(room) {
  return (axios
    .post("https://my-pg.vercel.app/Room/", {
      roomname: room.roomname,
      beds: room.beds,
      pgname: room.pgname,
    })
    .then((res) => {
      // console.log(res);
      alert("Room Created Successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export function updateRoom(room, id) {
  return (axios
    .put("https://my-pg.vercel.app/Room/" + id + "/", {
      roomname: room.roomname,
      beds: room.beds,
      pgname: room.pgname,
    })
    .then((res) => {
      // console.log(res);
      alert("Room Updated Successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export async function deleteRoom(id) {
  try {
    const res = await axios.delete("https://my-pg.vercel.app/Room/" + id + "/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

/* **********Tenant Related Api's************/

export async function getTenant() {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Guest/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getTenantByRoom(room) {
  try {
    const res = await axios.get(
      "https://my-pg.vercel.app/Guest/?roomNo=" + room
    );
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getTenantByPg(pg) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Guest/?pgname=" + pg);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getTenantByID(id) {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Guest/" + id + "/");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export function addTenant(guest) {
  return (axios
    .post("https://my-pg.vercel.app/Guest/", {
      name: guest.name,
      mobileno: guest.mobileno,
      aadharNo: guest.aadharNo,
      joinedDate: guest.joinedDate,
      rentAmt: guest.rentAmt,
      balAmt: guest.balAmt,
      advAmt: guest.advAmt,
      paymentDate: guest.paymentDate,
      paid: guest.paid,
      pgname: guest.pgname,
      roomNo: guest.roomNo,
    })
    .then((res) => {
      // console.log(res);
      alert("Guest Added successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export function updateTenant(guest, id) {
  return (axios
    .put("https://my-pg.vercel.app/Guest/" + id + "/", {
      name: guest.name,
      mobileno: guest.mobileno,
      aadharNo: guest.aadharNo,
      joinedDate: guest.joinedDate,
      rentAmt: guest.rentAmt,
      balAmt: guest.balAmt,
      advAmt: guest.advAmt,
      paymentDate: guest.paymentDate,
      paid: guest.paid,
      pgname: guest.pgname,
      roomNo: guest.roomNo,
    })
    .then((res) => {
      // console.log(res);
      alert("Guest Updated successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export async function deleteTenant(id) {
  try {
    const res = await axios.delete(
      "https://my-pg.vercel.app/Guest/" + id + "/"
    );
    alert("Guest Deleted successfully");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

/* **********Old Guest's Related Api's************/

export function addOldGuest(guest) {
  return (axios
    .post("https://my-pg.vercel.app/oldGuest/", {
      name: guest.name,
      mobileno: guest.mobileno,
      aadharNo: guest.aadharNo,
      joinedDate: guest.joinedDate,
      totalAmt: guest.totalAmt,
      vacatedDate: guest.vacatedDate,
      pgname: guest.pgname,
      roomNo: guest.roomNo,
    })
    .then((res) => {
      // console.log(res);
      alert("Guest Vacated successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

/* **********Payment Related Api's************/

export function addPayment(payment) {
  return (axios
    .post("https://my-pg.vercel.app/Payment/", {
      id: null,
      pname: payment.pname,
      pamount: payment.pamount,
      paadhar: payment.paadhar,
      paymentDate: payment.paymentDate,
      pgname: payment.pgname,
    })
    .then((res) => {
      // console.log(res);
      alert("Payment done successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export async function getPayments() {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Payment/");
    // console.log(res.data);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getPaymentsByPg(pg) {
  try {
    const res = await axios.get(
      "https://my-pg.vercel.app/Payment/?pgname=" + pg
    );
    // console.log(res.data);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function deletePayment(id) {
  try {
    const res = await axios.delete(
      "https://my-pg.vercel.app/Payment/" + id + "/"
    );
    alert("Payment deleted successfully");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

/* **********Expenses Related Api's************/

export async function getExpenses() {
  try {
    const res = await axios.get("https://my-pg.vercel.app/Expenses/");
    // console.log(res.data);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export async function getExpensesByPg(pg) {
  try {
    const res = await axios.get(
      "https://my-pg.vercel.app/Expenses/?pgname=" + pg
    );
    // console.log(res.data);
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}

export function addExpense(exp) {
  return (axios
    .post("https://my-pg.vercel.app/Expenses/", {
      expName: exp.expName,
      expAmt: exp.expAmt,
      expDate: exp.expDate,
      pgname: exp.pgname,
    })
    .then((res) => {
      // console.log(res);
      alert("Expense Added successfully");
    }).catch = (e) => {
    console.log(e);
  });
}

export async function deleteExpense(id) {
  try {
    const res = await axios.delete(
      "https://my-pg.vercel.app/Expenses/" + id + "/"
    );
    alert("Expense deleted Refresh to update");
    return res.data;
  } catch (e) {
    return console.log(e);
  }
}
